import * as _ from 'lodash';
import IIsNotCalibratedReason = ZoneIQCalibration.IIsNotCalibratedReason;
import { IsNotCalibratedReason } from 'src/app/interfaces/is-not-calibrated-reason.interface';

export class IsNotCalibratedReasonModel implements IsNotCalibratedReason {
    Id: number;
    Reason: string;
    IsDefault: boolean;
    Order: number;
    CreatedOn: string;
    ModifiedOn: string;

    constructor(data: IIsNotCalibratedReason) {
        Object.assign(this, _.pick(data, ['Id', 'Reason', 'IsDefault', 'Order', 'CreatedOn', 'ModifiedOn']));
    }

    static factory(data: IIsNotCalibratedReason) {
        return new IsNotCalibratedReasonModel(data);
    }
}
